import { render, staticRenderFns } from "./onetimeWallet.vue?vue&type=template&id=2b90eedf&scoped=true"
import script from "./onetimeWallet.vue?vue&type=script&lang=js"
export * from "./onetimeWallet.vue?vue&type=script&lang=js"
import style0 from "./onetimeWallet.vue?vue&type=style&index=0&id=2b90eedf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b90eedf",
  null
  
)

export default component.exports